module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("agmkt"))).then(() => parcelRequire('hEqeo'));